module.exports = __webpack_public_path__ + "img/roosternft.382c442c.webp";